module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-btn-form', {
    attrs: {
      "title": _vm.title,
      "mode": _vm.edit
    },
    on: {
      "close": function($event) {
        return _vm.cancel()
      }
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function() {
        return [(!_vm.isEdit) ? _c('v-btn', {
          on: {
            "click": function($event) {
              _vm.edit = !_vm.edit
            }
          }
        }, [_vm._v("Изменить")]) : _vm._e(), _vm._v(" "), (_vm.isEdit) ? _c('v-btn', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!_vm.isNew),
            expression: "!isNew"
          }],
          on: {
            "click": _vm.save
          }
        }, [_vm._v("Сохранить")]) : _vm._e(), _vm._v(" "), (_vm.isEdit) ? _c('v-btn', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!_vm.isNew),
            expression: "!isNew"
          }],
          on: {
            "click": _vm.remove
          }
        }, [_vm._v("Удалить")]) : _vm._e(), _vm._v(" "), (_vm.isEdit) ? _c('v-btn', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.isNew),
            expression: "isNew"
          }],
          attrs: {
            "disabled": !_vm.partner || !_vm.partner.clientId
          },
          on: {
            "click": _vm.add
          }
        }, [_vm._v("Создать")]) : _vm._e(), _vm._v(" "), _c('v-spacer')]
      },
      proxy: true
    }])
  }, [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [(!_vm.isEdit) ? _c('v-flex', [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.item.name))])]), _vm._v(" "), _c('v-card-text')], 1) : _vm._e(), _vm._v(" "), (_vm.isEdit) ? _c('v-flex', [_c('v-card-text', [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "sm8": "",
      "xs12": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": "Партнер",
      "readonly": "",
      "auto-grow": "",
      "rows": "1",
      "value": _vm.partnerDescription
    },
    on: {
      "click": _vm.selectClient
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm4": "",
      "xs4": ""
    }
  }, [_c('v-btn', {
    on: {
      "click": _vm.selectClient
    }
  }, [_vm._v("Выбрать партнера")])], 1)], 1), _vm._v(" "), _c('v-flex', [_c('v-text-field', {
    attrs: {
      "label": "Название",
      "hint": "Название беседы",
      "clearable": ""
    },
    model: {
      value: (_vm.item.name),
      callback: function($$v) {
        _vm.$set(_vm.item, "name", $$v)
      },
      expression: "item.name"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isNew),
      expression: "isNew"
    }]
  }, [_c('v-text-field', {
    attrs: {
      "label": "Сообщение",
      "hint": "",
      "clearable": ""
    },
    model: {
      value: (_vm.item.msg),
      callback: function($$v) {
        _vm.$set(_vm.item, "msg", $$v)
      },
      expression: "item.msg"
    }
  })], 1)], 1)], 1)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27bfdceb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat/ChatForm.vue
// module id = 1192
// module chunks = 1